import axios from "axios";
import { ENDPOINTS } from "./ENDPOINTS";

export const GeneralService = {

    // one for all

    create: async (table, data) => {
        try {
            const response = await axios.post(`${ENDPOINTS.CREATE}?table=${table}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    get: async (table) => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET}?table=${table}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    update: async (table,id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.UPDATE}?table=${table}&id=${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
    delete: async (table,id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.DELETE}?table=${table}&id=${id}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error; 
        }
    },
};
